/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Not_Found_TitleInputs */

const en_platform_not_found_title = /** @type {(inputs: Platform_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API not found`)
};

const zh_hans1_platform_not_found_title = /** @type {(inputs: Platform_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到该 API`)
};

const pt_br2_platform_not_found_title = /** @type {(inputs: Platform_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API não encontrada`)
};

const es_platform_not_found_title = /** @type {(inputs: Platform_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API no encontrada`)
};

const fr_platform_not_found_title = /** @type {(inputs: Platform_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API introuvable`)
};

const de_platform_not_found_title = /** @type {(inputs: Platform_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API nicht gefunden`)
};

const ru_platform_not_found_title = /** @type {(inputs: Platform_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API не найден`)
};

const it_platform_not_found_title = /** @type {(inputs: Platform_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API non trovata`)
};

/**
* | output |
* | --- |
* | "API not found" |
*
* @param {Platform_Not_Found_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_not_found_title = /** @type {((inputs?: Platform_Not_Found_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Not_Found_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_not_found_title(inputs)
	if (locale === "pt-BR") return pt_br2_platform_not_found_title(inputs)
	if (locale === "es") return es_platform_not_found_title(inputs)
	if (locale === "fr") return fr_platform_not_found_title(inputs)
	if (locale === "de") return de_platform_not_found_title(inputs)
	if (locale === "ru") return ru_platform_not_found_title(inputs)
	if (locale === "it") return it_platform_not_found_title(inputs)
	return en_platform_not_found_title(inputs)
});